"use client";

import { useEffect, useState } from "react";
import { useCart } from "react-use-cart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { FadeInDiv } from "@/app/components/FadesIn";

interface AddToCartProps {
  products: { id: string, name: string, price: number, stock: number, image: string, minBuy: number }[];
}

export default function AddToCart({ products }: AddToCartProps) {
  const { addItem } = useCart();

  const result = products.find(item => item.stock >= item.minBuy)

  const [selectedProductId, setSelectedProductId] = useState(result?.id);
  
  const selectedProduct = products.find((p) => p.id === selectedProductId);

  let allStock = products.reduce((sum, p) => sum + p.stock, 0);

  const [quantity, setQuantity] = useState(selectedProduct?.minBuy || 0);
  const [message, setMessage] = useState("");

  const handleAddToCart = () => {
    if (!selectedProduct) return;
    if (selectedProduct.stock < quantity) {
      setMessage("This product is out of stock!")
      return;
    }
    addItem({ ...selectedProduct }, quantity);
    setMessage("Added " + selectedProduct.name + " x" + quantity + " to cart!")

    setTimeout(() => {
      setMessage("")
    }, 2000)
  };

  useEffect(() => {
    setQuantity(selectedProduct?.minBuy || 0);
  }, [selectedProduct]);

  return (
    <div>
      <select
        value={selectedProductId}
        onChange={e => {
          setSelectedProductId(e.target.value)
        }}
        className="w-full text-[12px] sm:text-[14px] border-2 rounded-lg text-white border-[#464646] bg-[rgb(31,39,52)] mt-5 p-2"
      >
        {products.map((product) => (
          product.stock == 0 ?
            <option key={product.id} value={product.id} disabled>
              {product.name} - {product.stock} in stock - ${product.price.toFixed(2)}
            </option>
            :
            <option key={product.id} value={product.id}>
              {product.name} - {product.stock} in stock - ${product.price.toFixed(2)}
            </option>
        ))}
      </select>

      {allStock <= 0 ? "" :
        <input
          type="number"
          value={quantity}
          min={selectedProduct?.minBuy}
          max={selectedProduct?.stock}
          onChange={(e) => {
            let quantity = 0;

            try {
              quantity = parseInt(e.target.value)
            } catch {
              quantity = selectedProduct?.minBuy || 0;
            }

            if (isNaN(quantity)) {
              quantity = selectedProduct?.minBuy || 0;
            }

            if (quantity > (selectedProduct?.stock || 0)) {
              quantity = selectedProduct?.stock || 0;
            } else if (quantity < (selectedProduct?.minBuy || 0)) {
              quantity = selectedProduct?.minBuy || 0;
            }

            setQuantity(quantity)
          }}
          /*onChange={e => setQuantity(Number(e.target.value))}*/
          className="w-full text-[12px] sm:text-[14px] border-2 rounded-lg text-white border-[#464646] mt-5 p-2"
          placeholder="Enter quantity"
        />
      }
      {message != "" ? <FadeInDiv><div className={`border-2 ${message.includes("Added") ? "border-[rgba(0,200,0,0.8)] bg-[rgba(0,200,0,0.3)] text-[rgb(0,200,0)]" : "border-[rgba(200,0,0,0.8)] bg-[rgba(200,0,0,0.3)] text-[rgb(200,0,0)]"}  mt-3 rounded-lg p-2 font-bold`}>{message}</div></FadeInDiv> : ""}
      
      {allStock <= 0 ?
        <button
          className="cursor-not-allowed w-full my-5 p-[7px] text-[1rem] mt-[20px] border-2 border-[rgb(255,117,22,0.8)] bg-[rgb(255,117,22,0.3)] text-white font-bold px-2 sm:px-8 py-2 rounded-lg transition-all duration-[0.2s] ease-linear"
        >
          <FontAwesomeIcon className="mx-2" icon={faShoppingCart} /> Product Out Of Stock
        </button>
        :
        <button
          onClick={handleAddToCart}
          className="cursor-pointer w-full my-5 p-[7px] text-[1rem] mt-[20px] border-2 border-[rgb(255,117,22,0.8)] bg-[rgb(255,117,22,0.3)] text-white font-bold px-2 sm:px-8 py-2 rounded-lg hover:bg-[rgb(255,117,22,0.8)] transition-all duration-[0.2s] ease-linear"
        >
          <FontAwesomeIcon className="mx-2" icon={faShoppingCart} /> Add To Cart
        </button>
      }
    </div>
  );
}
